import React from "react";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import DragHandleIcon from "@material-ui/icons/DragHandle";
import { ArrowUpwardIconStyled } from "./styles";

const icon = {
  0: <DragHandleIcon color="primary" />,
  1: <ArrowUpwardIconStyled />,
  "-1": <ArrowDownwardIcon color="secondary" />,
};

export const PricesIcon = React.memo(({ grow = 0 }) => {
  return <>{icon[grow]}</>;
});
